import { render } from "./HomeworkAttendedView.vue?vue&type=template&id=b781595a&scoped=true"
import script from "./HomeworkAttendedView.vue?vue&type=script&lang=js"
export * from "./HomeworkAttendedView.vue?vue&type=script&lang=js"

import "./HomeworkAttendedView.vue?vue&type=style&index=0&id=b781595a&lang=scss&scoped=true"

import exportComponent from "/home/misha/Рабочий стол/kolos-system-front-trainer/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b781595a"]])

export default __exports__